import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ToggleBox from 'app/components/ToggleBox'
import ImageCropper from 'app/components/ImageCropper'
import Search from './GallerySearch'
import { ACTIVITY_IMAGE } from 'app/constants/gallery'

class Gallery extends Component {
  static propTypes = {
    loaded: PropTypes.bool,
    GalleryItemsComponent: PropTypes.object.isRequired,
  }

  state = {
    cropperImage: null,
  }

  componentDidMount() {
    if (!this.props.loaded) {
      this.props.getItems()
    }
  }

  setCropperImage = image => {
    this.setState({ cropperImage: image })
  }

  render() {
    const {
      input,
      meta,
      galleryImages,
      uploadImageRequest,
      imageInputProps,
      innerModifier,
      s3Entity,
      GalleryItemsComponent,
      GalleryInput,
      renderColorPickerField,
      color,
      showModal,
      minImageWidth = 0,
      minImageHeight = 0,
      isSkipCropper,
      organizations,
      handleOnChange,
    } = this.props
    const { cropperImage } = this.state
    return (
      <div className="gallery">
        <GalleryInput
          input={input}
          meta={meta}
          uploadImageRequest={(file, mime, ext, name, isConfirmRewriteImage) =>
            uploadImageRequest({ file, mime, ext, name }, meta.form, input.name, s3Entity, isConfirmRewriteImage)
          }
          {...imageInputProps}
          renderColorPickerField={renderColorPickerField}
          organizations={organizations}
          handleOnChange={handleOnChange}
          color={color}
          isSkipCropper={isSkipCropper}
        />
        <ToggleBox contentLabel="gallery">
          {innerModifier === ACTIVITY_IMAGE && <Search />}
          <GalleryItemsComponent
            images={galleryImages}
            currentImage={input.value}
            selectImage={({ url }) => {
              this.setState({ cropperImage: null })
              input.onChange(url)
            }}
            setCropperImage={this.setCropperImage}
            innerModifier={innerModifier}
            minImageWidth={minImageWidth}
            minImageHeight={minImageHeight}
            isSkipCropper={isSkipCropper}
            showModal={img => {
              const image = cropperImage || img
              return showModal(
                <ImageCropper
                  onSave={(canvas, canvasScaled) => {
                    uploadImageRequest(
                      { file: canvasScaled, mime: image.mime, ext: image.ext },
                      meta.form,
                      input.name,
                      s3Entity
                    )
                  }}
                  onCancel={() => {
                    this.setState({ cropperImage: null })
                  }}
                  handleWillUnmount={() => this.setState({ cropperImage: null })}
                  file={image && image.url}
                  isModal
                  {...imageInputProps.cropper}
                />,
                { size: 'sm' }
              )
            }}
          />
        </ToggleBox>
      </div>
    )
  }
}

Gallery.displayName = 'Gallery'

export default Gallery
